import SendInviteUserModal from './SendInviteUserModal';

export default SendInviteUserModal;
